/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { Brush } from "igniteui-react-core";
import { Color } from "igniteui-react-core";
import { FontInfo } from "igniteui-react-core";
import { DeviceUtils } from "igniteui-react-core";
import { Thickness } from "igniteui-react-core";
import { CornerRadius } from "igniteui-react-core";
import { truncate } from "igniteui-react-core";
/**
 * @hidden
 */
var GridStyleRepository = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridStyleRepository, _super);
    function GridStyleRepository() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(GridStyleRepository, "be", {
        get: function () {
            if (GridStyleRepository.an == null) {
                var a_1 = "#babfc7";
                GridStyleRepository.an = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_1;
                    return $ret;
                })());
            }
            return GridStyleRepository.an;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "bg", {
        get: function () {
            if (GridStyleRepository.ap == null) {
                var a_2 = "#dde2eb";
                GridStyleRepository.ap = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_2;
                    return $ret;
                })());
            }
            return GridStyleRepository.ap;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "a9", {
        get: function () {
            if (GridStyleRepository.ai == null) {
                GridStyleRepository.ai = ((function () {
                    var $ret = new Brush();
                    $ret.color = Color.u(255, 224, 224, 224);
                    return $ret;
                })());
            }
            return GridStyleRepository.ai;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "az", {
        get: function () {
            if (GridStyleRepository.y == null) {
                var a_3 = "#babfc7";
                GridStyleRepository.y = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_3;
                    return $ret;
                })());
            }
            return GridStyleRepository.y;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "ay", {
        get: function () {
            if (GridStyleRepository.x == null) {
                var a_4 = "#babfc7";
                GridStyleRepository.x = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_4;
                    return $ret;
                })());
            }
            return GridStyleRepository.x;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "bi", {
        get: function () {
            if (GridStyleRepository.ar == null) {
                var a_5 = "#ff80ab";
                GridStyleRepository.ar = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_5;
                    return $ret;
                })());
            }
            return GridStyleRepository.ar;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "bj", {
        get: function () {
            if (GridStyleRepository.as == null) {
                var a_6 = "#181d1f";
                GridStyleRepository.as = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_6;
                    return $ret;
                })());
            }
            return GridStyleRepository.as;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "at", {
        get: function () {
            if (GridStyleRepository.s == null) {
                var a_7 = "#2196f3";
                GridStyleRepository.s = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_7;
                    return $ret;
                })());
            }
            return GridStyleRepository.s;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "l", {
        get: function () {
            if (GridStyleRepository.g == null) {
                GridStyleRepository.g = new FontInfo();
                GridStyleRepository.g.d = DeviceUtils.f(13);
                GridStyleRepository.g.n = "'Segoe UI', Verdana";
            }
            return GridStyleRepository.g;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "k", {
        get: function () {
            if (GridStyleRepository.f == null) {
                GridStyleRepository.f = new FontInfo();
                GridStyleRepository.f.d = DeviceUtils.f(13);
                GridStyleRepository.f.q = "italic";
                GridStyleRepository.f.n = "'Segoe UI', Verdana";
            }
            return GridStyleRepository.f;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "h", {
        get: function () {
            if (GridStyleRepository.c == null) {
                GridStyleRepository.c = new FontInfo();
                GridStyleRepository.c.d = DeviceUtils.f(14);
                GridStyleRepository.c.n = "'Segoe UI', Verdana";
            }
            return GridStyleRepository.c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "j", {
        get: function () {
            if (GridStyleRepository.d == null) {
                GridStyleRepository.d = new FontInfo();
                GridStyleRepository.d.d = DeviceUtils.f(12);
                GridStyleRepository.d.s = "600";
                GridStyleRepository.d.n = "'Segoe UI', Verdana";
            }
            return GridStyleRepository.d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "i", {
        get: function () {
            if (GridStyleRepository.e == null) {
                GridStyleRepository.e = new FontInfo();
                GridStyleRepository.e.d = DeviceUtils.f(12);
                GridStyleRepository.e.n = "'Segoe UI', Verdana";
            }
            return GridStyleRepository.e;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "a7", {
        get: function () {
            if (GridStyleRepository.ag == null) {
                GridStyleRepository.ag = new Brush();
                GridStyleRepository.ag.color = Color.u(255, 210, 234, 253);
            }
            return GridStyleRepository.ag;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "au", {
        get: function () {
            if (GridStyleRepository.t == null) {
                GridStyleRepository.t = ((function () {
                    var $ret = new Brush();
                    $ret.fill = "White";
                    return $ret;
                })());
            }
            return GridStyleRepository.t;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "bd", {
        get: function () {
            if (GridStyleRepository.am == null) {
                var a_8 = "#F8F8F8";
                GridStyleRepository.am = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_8;
                    return $ret;
                })());
            }
            return GridStyleRepository.am;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "bh", {
        get: function () {
            if (GridStyleRepository.aq == null) {
                var a_9 = "#181d1f";
                GridStyleRepository.aq = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_9;
                    return $ret;
                })());
            }
            return GridStyleRepository.aq;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "bf", {
        get: function () {
            if (GridStyleRepository.ao == null) {
                var a_10 = "#181d1f";
                GridStyleRepository.ao = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_10;
                    return $ret;
                })());
            }
            return GridStyleRepository.ao;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "a5", {
        get: function () {
            if (GridStyleRepository.ae == null) {
                var a_11 = "#fafafa";
                GridStyleRepository.ae = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_11;
                    return $ret;
                })());
            }
            return GridStyleRepository.ae;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "a4", {
        get: function () {
            if (GridStyleRepository.ad == null) {
                GridStyleRepository.ad = ((function () {
                    var $ret = new Brush();
                    $ret.fill = "#f5f5dc";
                    return $ret;
                })());
            }
            return GridStyleRepository.ad;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "a8", {
        get: function () {
            if (GridStyleRepository.ah == null) {
                var a_12 = "#ffffff";
                GridStyleRepository.ah = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_12;
                    return $ret;
                })());
            }
            return GridStyleRepository.ah;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "a1", {
        get: function () {
            if (GridStyleRepository.aa == null) {
                var a_13 = "#ffffff";
                GridStyleRepository.aa = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_13;
                    return $ret;
                })());
            }
            return GridStyleRepository.aa;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "a3", {
        get: function () {
            if (GridStyleRepository.ac == null) {
                var a_14 = "#f8f8f8";
                GridStyleRepository.ac = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_14;
                    return $ret;
                })());
            }
            return GridStyleRepository.ac;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "a6", {
        get: function () {
            if (GridStyleRepository.af == null) {
                var a_15 = "#fafafa";
                GridStyleRepository.af = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_15;
                    return $ret;
                })());
            }
            return GridStyleRepository.af;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "ba", {
        get: function () {
            if (GridStyleRepository.aj == null) {
                var a_16 = "#0099FF";
                GridStyleRepository.aj = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_16;
                    return $ret;
                })());
            }
            return GridStyleRepository.aj;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "bb", {
        get: function () {
            if (GridStyleRepository.ak == null) {
                var a_17 = "#181d1f";
                GridStyleRepository.ak = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_17;
                    return $ret;
                })());
            }
            return GridStyleRepository.ak;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "aw", {
        get: function () {
            if (GridStyleRepository.v == null) {
                var a_18 = "#2196f3";
                GridStyleRepository.v = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_18;
                    return $ret;
                })());
            }
            return GridStyleRepository.v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "a2", {
        get: function () {
            if (GridStyleRepository.ab == null) {
                var a_19 = "#2196f3";
                GridStyleRepository.ab = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_19;
                    return $ret;
                })());
            }
            return GridStyleRepository.ab;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "a0", {
        get: function () {
            if (GridStyleRepository.z == null) {
                var a_20 = "#babfc7";
                GridStyleRepository.z = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_20;
                    return $ret;
                })());
            }
            return GridStyleRepository.z;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "ax", {
        get: function () {
            if (GridStyleRepository.w == null) {
                var a_21 = "#181d1f";
                GridStyleRepository.w = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_21;
                    return $ret;
                })());
            }
            return GridStyleRepository.w;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "a", {
        get: function () {
            return 2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "b", {
        get: function () {
            return 3;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "o", {
        get: function () {
            return truncate(DeviceUtils.g(30));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "p", {
        get: function () {
            return truncate(DeviceUtils.g(36));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "n", {
        get: function () {
            return truncate(DeviceUtils.g(40));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "av", {
        get: function () {
            if (GridStyleRepository.u == null) {
                var a_22 = "#babfc7";
                GridStyleRepository.u = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_22;
                    return $ret;
                })());
            }
            return GridStyleRepository.u;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "bl", {
        get: function () {
            return GridStyleRepository.bk;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "r", {
        get: function () {
            return GridStyleRepository.q;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridStyleRepository, "bc", {
        get: function () {
            if (GridStyleRepository.al == null) {
                var a_23 = "#ff0000";
                GridStyleRepository.al = ((function () {
                    var $ret = new Brush();
                    $ret.fill = a_23;
                    return $ret;
                })());
            }
            return GridStyleRepository.al;
        },
        enumerable: true,
        configurable: true
    });
    GridStyleRepository.$t = markType(GridStyleRepository, 'GridStyleRepository');
    GridStyleRepository.an = null;
    GridStyleRepository.ap = null;
    GridStyleRepository.ai = null;
    GridStyleRepository.y = null;
    GridStyleRepository.x = null;
    GridStyleRepository.ar = null;
    GridStyleRepository.as = null;
    GridStyleRepository.s = null;
    GridStyleRepository.g = null;
    GridStyleRepository.f = null;
    GridStyleRepository.m = 0.54;
    GridStyleRepository.c = null;
    GridStyleRepository.d = null;
    GridStyleRepository.e = null;
    GridStyleRepository.ag = null;
    GridStyleRepository.t = null;
    GridStyleRepository.am = null;
    GridStyleRepository.aq = null;
    GridStyleRepository.ao = null;
    GridStyleRepository.ae = null;
    GridStyleRepository.ad = null;
    GridStyleRepository.ah = null;
    GridStyleRepository.aa = null;
    GridStyleRepository.ac = null;
    GridStyleRepository.af = null;
    GridStyleRepository.aj = null;
    GridStyleRepository.ak = null;
    GridStyleRepository.v = null;
    GridStyleRepository.ab = null;
    GridStyleRepository.z = null;
    GridStyleRepository.w = null;
    GridStyleRepository.u = null;
    GridStyleRepository.bk = new Thickness(0, 1);
    GridStyleRepository.q = new CornerRadius(0, 3);
    GridStyleRepository.al = null;
    return GridStyleRepository;
}(Base));
export { GridStyleRepository };
//# sourceMappingURL=GridStyleRepository.js.map
